export const signUpUrl = function(lang, params = {}) {
  params['lang'] = lang;

  var queryString = Object.keys(params).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');

  if (Object.keys(params).length > 0) {
    return `https://app.dealfront.com/f/sign/up/start?${queryString}`;
  } else {
    return "https://app.dealfront.com/f/sign/up/start";
  }
}

export const loginUrl = (lang) => `https://app.dealfront.com/f/sign/in${lang !== 'en' ? `?lang=${lang}` : ""}`;

export const requestDemoUrl = function(lang, params = {}) {
  if (lang !== 'en') {
    params['lang'] = lang;
  }

  var queryString = Object.keys(params).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');

  if (Object.keys(params).length > 0) {
    return `/request-demo?${queryString}`;
  } else {
    return "/request-demo";
  }
}

